import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

async function runNativeHaptic(action) {
    if (!Capacitor.isNativePlatform()) return;

    try {
        await action();
    } catch {
        // Haptics are supplementary feedback and must never block the action.
    }
}

export function hapticMenuOpened() {
    return runNativeHaptic(() => Haptics.impact({ style: ImpactStyle.Light }));
}

export function hapticRecorded() {
    return runNativeHaptic(() => Haptics.impact({ style: ImpactStyle.Light }));
}

export function hapticCompleted() {
    return runNativeHaptic(() => Haptics.notification({ type: NotificationType.Success }));
}

export function hapticWarning() {
    return runNativeHaptic(() => Haptics.notification({ type: NotificationType.Warning }));
}

export function hapticError() {
    return runNativeHaptic(() => Haptics.notification({ type: NotificationType.Error }));
}
